module.exports = __webpack_public_path__ + "img/Shiba-BG.cdfd5dae.jpg";